import { useStyles } from '@team-griffin/stylr';
import cssSides, { Side } from '@team-griffin/css-sides';
import { useBreakpoints } from '@uds/responsive';
import { css } from 'linaria';
import { gu2px, Theme, cssTheme } from '@uds/theme-utils';

const title = css`
  text-align: center;
  margin-bottom: ${cssTheme.gu3};
  &&& {
    ${cssTheme.breakpoints.lg} {
      white-space: no-wrap;
      margin: 0 calc(${cssTheme.gu1} * 1.5);
    }
  }
`;

export const getClassNames = () => {
  return {
    title,
  };
};
export default ({ theme }: { theme: Theme }) => {
  const { isMinMd, isMinLg } = useBreakpoints();

  const { spacing } = theme;

  return useStyles(
    {
      default: {
        content: {
          ...cssSides('padding', Side.A, gu2px(3, spacing)),
          justifyContent: 'center',
          display: 'flex',
          flexDirection: 'column',
        },
      },
      isMinMd: {
        content: {
          alignItems: 'center',
        },
        search: {
          flex: 1,
          flexBasis: 'auto', // IE 11 fix
          minWidth: `${(100 / 12) * 8}%`,
          ...cssSides('margin', Side.X, 'auto'),
        },
      },
      isMinLg: {
        content: {
          // 2.5 + 1.5 = 4GU padding to implement padding-box rules
          ...cssSides('padding', Side.X, gu2px(2.5, spacing)),
          ...cssSides('padding', Side.Y, gu2px(2.5, spacing)),
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          flexWrap: 'wrap',
        },
        search: {
          ...cssSides('margin', Side.A, gu2px(1.5, spacing)),
          flex: 1,
          // min-width is 4 col
          minWidth: `${(100 / 12) * 4}%`,
          maxWidth: '50%',
        },
      },
    },
    [{ isMinMd }, { isMinLg }],
  );
};
